export default __webpack_public_path__ + "static/media/Slide 4.fe997ede.png";